import React from 'react';
import { Helmet } from 'react-helmet';
import PageWrapper, { PageCard, PageTitle, SectionH2, Para } from '../../components/Layout/PageWrapper';

function Terms() {
  return (
    <PageWrapper>
      <Helmet>
        <title>Terms & Conditions | TheGameZone</title>
        <meta name="description" content="Read the TheGameZone Terms and Conditions for using our free online gaming platform." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://thegamezone.fun/terms" />
      </Helmet>
      <PageCard>
        <PageTitle>Terms & Conditions</PageTitle>
        <SectionH2>Introduction</SectionH2>
        <Para>Welcome to TheGameZone! These terms and conditions outline the rules for using TheGameZone at https://thegamezone.fun/.</Para>
        <Para>By accessing this website, you accept these terms. Do not continue to use TheGameZone if you do not agree to all terms stated here.</Para>
        <SectionH2>Cookies</SectionH2>
        <Para>We employ the use of cookies. By using TheGameZone, you consent to the use of cookies in accordance with our Privacy Policy.</Para>
        <SectionH2>License</SectionH2>
        <Para>Unless otherwise stated, TheGameZone and its licensors own the intellectual property rights for all material on this website. All rights are reserved.</Para>
        <Para>You may view and/or print pages for your personal use, subject to restrictions set in these terms and conditions.</Para>
        <SectionH2>Restrictions</SectionH2>
        <Para>You are specifically restricted from publishing any website material in any media without permission, selling or commercializing any website material, using this website in a way that damages or affects user access, and using this website contrary to applicable laws.</Para>
        <SectionH2>Disclaimer</SectionH2>
        <Para>To the maximum extent permitted by law, TheGameZone excludes all representations, warranties, and conditions relating to this website and its use.</Para>
        <SectionH2>Governing Law</SectionH2>
        <Para>These terms are governed by the applicable laws. By using TheGameZone, you agree to the exclusive jurisdiction of its courts.</Para>
        <SectionH2>Contact</SectionH2>
        <Para>If you have any questions about these Terms, please contact us at info@thegamezone.fun.</Para>
      </PageCard>
    </PageWrapper>
  );
}

export default Terms;
